import apiDataSourcePlugin from './dataSource/api/apiDataSource.plugin';
// import dataSourcePlugin from "./dataSource/dataSource.plugin";
import Vue from 'vue';
// глобальная регистрация компонентов из файла, сгенерированого webpack (filebuilder)
import './load';
import App from './views/app.vue';
import pluginComponents from './plugins/plugin.components';
// регистрация плагина $dialog. Использование
//this.$dialog.confirm('Вы действительно хотите ...?').then((res: boolean) => {
// if(res) { делаем что-то }
//})
import dialogPlugin from './plugins/dialog/plugin.dialog';
Vue.use(dialogPlugin);
// регистрация плагина $notification. Использование
//this.$notification.error('Ошибка при выполнении операции?')
//this.$notification.success('Данные успешно сохранены?')
import notificationPlugin from './plugins/notification/plugin.notification';
Vue.use(notificationPlugin);
import './filters/moment.ts';
import './filters/terminaleStatusName';
import './filters/terminaleTypeName';

import localizationPlugin from './plugins/localization/plugin.localization';
Vue.use(localizationPlugin);

Vue.use(pluginComponents);
import * as moment from 'moment';
moment.locale('ru');

// поддержка ui-components pack от tirscript
import uiComponents from 'ui-components';

declare var websocketUrl: string;
let resultWebsocketUrl = websocketUrl;
if (resultWebsocketUrl.startsWith('/')) {
  resultWebsocketUrl = location.protocol.replace('http', 'ws') + '//' + location.host + resultWebsocketUrl;
  //resultWebsocketUrl =   "ws://runpay-admin-api.tirscript.com/websocket";
}
Vue.use(apiDataSourcePlugin, resultWebsocketUrl, true); //ws://test-admin.runpay.com/websocket //"ws://runpay-admin-api.tirscript.com/websocket"
// Vue.use(dataSourcePlugin)

import router from './router';
const v = new Vue({
  el: '#app',
  router: router,
  template: `<App/>`,
  components: { App, uiComponents },
});



// WEBPACK FOOTER //
// ./scripts/main.ts